import React from 'react'
import {Route, Switch} from 'react-router-dom'
import About from './about/About'
import PersonalStats from './personal-stats/PersonalStats'
import SpacecastGlobalExplorer from "../explore/items/SpacecastGlobalExplorer";
import SpacecastExplorer from "../explore/items/SpacecastExplorer";
import {Container} from "@material-ui/core";

const Spacecast = () => (
  <div style={{position:'relative', height:'100%'}}>
    <Container maxWidth={false} style={
      {
        paddingTop: '1rem',
        backgroundColor: "rgba(0, 62, 88, 0.025)",
        height: '100%'
      }}>
      <Switch>
        <Route exact path="/spacecast" component={About}/>
        <Route path="/spacecast/about" component={About}/>
        <Route path="/spacecast/personal-stats" component={PersonalStats}/>
        <Route path="/spacecast/personal-log" component={SpacecastExplorer}/>
        <Route path="/spacecast/global-log" component={SpacecastGlobalExplorer}/>
      </Switch>
      <div id="spacecast" style={{position:'absolute', top:0, left:0}}></div>
    </Container>
  </div>
)

export default Spacecast
